<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <material-card
        color="primary"
        class="pt-2 mb-1 ml-7"
      >
        <template #heading>
          <div class="pl-4 pr-4 pt-1 pb-1 white--text">
            <div class="text-h3 font-weight-light">
              {{ selectedSalesPerson }}
            </div>
          </div>
        </template>
        <v-card-text class="pa-0">
          <v-data-table
            hide-default-footer
            disable-pagination
            class="mt-n7 font-weight-medium"
            item-class="font-weight-black"
            :items-per-page="itemsPerPage"
            :headers="salesPersonHeaders"
            :items="items"
          >
            <template
              v-slot:item.TotalTradeNow="{ item }"
            >
              {{ formatCurrency(item.TotalTradeNow) }}
            </template>
            <template v-slot:item.TradeVsLastYear="{ item }">
              <v-chip
                v-if="item.TradeVsLastYear > 0"
                outlined
                label
                class="ma-2"
                color="green"
              >
                {{ formatCurrency(item.TradeVsLastYear) }}
                <v-img
                  :src="upImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else-if="item.TradeVsLastYear < 0"
                outlined
                label
                class="white--text"
                color="red"
              >
                {{ formatCurrency(item.TradeVsLastYear) }}
                <v-img
                  :src="downImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else
                class="white--text"
                color="gray"
              >
                {{ formatCurrency(item.TradeVsLastYear) }}
              </v-chip>
            </template>
            <template v-slot:item.TradePercentVsLastYear="{ item }">
              <v-chip
                v-if="item.TradePercentVsLastYear > 0"
                outlined
                label
                class="white--text"
                color="green"
              >
                {{ formatPercentage(item.TradePercentVsLastYear) }}
                <v-img
                  :src="upImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else-if="item.TradePercentVsLastYear < 0"
                outlined
                label
                class="white--text"
                color="red"
              >
                {{ formatPercentage(item.TradePercentVsLastYear) }}
                <v-img
                  :src="downImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else
                class="white--text"
                color="gray"
              >
                {{ formatPercentage(item.TradePercentVsLastYear) }}
              </v-chip>
            </template>
            <template v-slot:item.TotalMSFNow="{ item }">
              {{ formatNumber(item.TotalMSFNow) }}
            </template>
            <template v-slot:item.MsfVsLastYear="{ item }">
              <v-chip
                v-if="item.MsfVsLastYear > 0"
                outlined
                label
                class="ma-2"
                color="green"
              >
                {{ formatNumber(item.MsfVsLastYear) }}
                <v-img
                  :src="upImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else-if="item.MsfVsLastYear < 0"
                outlined
                label
                class="white--text"
                color="red"
              >
                {{ formatNumber(item.MsfVsLastYear) }}
                <v-img
                  :src="downImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else
                class="white--text"
                color="gray"
              >
                {{ formatNumber(item.TradeVsLastYear) }}
              </v-chip>
            </template>
            <template v-slot:item.MsfPercentVsLastYear="{ item }">
              <v-chip
                v-if="item.MsfPercentVsLastYear > 0"
                outlined
                label
                class="white--text"
                color="green"
              >
                {{ formatPercentage(item.MsfPercentVsLastYear) }}
                <v-img
                  :src="upImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else-if="item.MsfPercentVsLastYear < 0"
                outlined
                label
                class="white--text"
                color="red"
              >
                {{ formatPercentage(item.MsfPercentVsLastYear) }}
                <v-img
                  :src="downImage"
                  height="10"
                  width="10"
                />
              </v-chip>
              <v-chip
                v-else
                class="white--text"
                color="gray"
              >
                {{ formatPercentage(item.MsfPercentVsLastYear) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </material-card>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="7"
        md="12"
      >
        <material-card
          ref="customerGridRef"
          color="success"
          full-header
          class="pt-n1"
        >
          <template #heading>
            <div class="pl-4 pr-4 pt-1 pb-1 white--text">
              <div class="text-h3 font-weight-light">
                <v-col>
                  <v-row>
                    Customers
                    <v-spacer />
                    <v-btn
                      v-if="selectedItems.length > 0"
                      class="ml-1 mr-3"
                      color="success"
                      depressed
                      small
                      @click="clearSelection"
                    >
                      Clear Selection
                      <v-icon class="ml-3">
                        mdi-filter-remove
                      </v-icon>
                    </v-btn>
                    <v-btn
                      color="white"
                      icon
                      small
                      @click="customerGridButtonClicked"
                    >
                      <v-icon>
                        mdi-axis-arrow
                      </v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              ref="CustomerGrid"
              item-key="Customer"
              class="mt-n4 font-weight-medium"
              item-class="font-weight-black"
              :items-per-page="itemsPerPage"
              :headers="headers"
              :items="sales"
              @click:row="tableClicked"
            >
              <template v-slot:item.TotalTradeNow="{ item }">
                {{ formatCurrency(item.TotalTradeNow) }}
              </template>
              <template v-slot:item.TradeVsLastYear="{ item }">
                <v-chip
                  v-if="item.TradeVsLastYear > 0"
                  outlined
                  label
                  class="ma-2"
                  color="green"
                >
                  {{ formatCurrency(item.TradeVsLastYear) }}
                  <v-img
                    :src="upImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else-if="item.TradeVsLastYear < 0"
                  outlined
                  label
                  class="white--text"
                  color="red"
                >
                  {{ formatCurrency(item.TradeVsLastYear) }}
                  <v-img
                    :src="downImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else
                  class="white--text"
                  color="gray"
                >
                  {{ formatCurrency(item.TradeVsLastYear) }}
                </v-chip>
              </template>
              <template v-slot:item.TradePercentVsLastYear="{ item }">
                <v-chip
                  v-if="item.TradePercentVsLastYear > 0"
                  outlined
                  label
                  class="white--text"
                  color="green"
                >
                  {{ formatPercentage(item.TradePercentVsLastYear) }}
                  <v-img
                    :src="upImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else-if="item.TradePercentVsLastYear < 0"
                  outlined
                  label
                  class="white--text"
                  color="red"
                >
                  {{ formatPercentage(item.TradePercentVsLastYear) }}
                  <v-img
                    :src="downImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else
                  class="white--text"
                  color="gray"
                >
                  {{ formatPercentage(item.TradePercentVsLastYear) }}
                </v-chip>
              </template>
              <template v-slot:item.TotalMSFNow="{ item }">
                {{ formatNumber(item.TotalMSFNow) }}
              </template>
              <template v-slot:item.MsfVsLastYear="{ item }">
                <v-chip
                  v-if="item.MsfVsLastYear > 0"
                  outlined
                  label
                  class="ma-2"
                  color="green"
                >
                  {{ formatNumber(item.MsfVsLastYear) }}
                  <v-img
                    :src="upImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else-if="item.MsfVsLastYear < 0"
                  outlined
                  label
                  class="white--text"
                  color="red"
                >
                  {{ formatNumber(item.MsfVsLastYear) }}
                  <v-img
                    :src="downImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else
                  class="white--text"
                  color="gray"
                >
                  {{ formatNumber(item.TradeVsLastYear) }}
                </v-chip>
              </template>
              <template v-slot:item.MsfPercentVsLastYear="{ item }">
                <v-chip
                  v-if="item.MsfPercentVsLastYear > 0"
                  outlined
                  label
                  class="white--text"
                  color="green"
                >
                  {{ formatPercentage(item.MsfPercentVsLastYear) }}
                  <v-img
                    :src="upImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else-if="item.MsfPercentVsLastYear < 0"
                  outlined
                  label
                  class="white--text"
                  color="red"
                >
                  {{ formatPercentage(item.MsfPercentVsLastYear) }}
                  <v-img
                    :src="downImage"
                    height="10"
                    width="10"
                  />
                </v-chip>
                <v-chip
                  v-else
                  class="white--text"
                  color="gray"
                >
                  {{ formatPercentage(item.MsfPercentVsLastYear) }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </material-card>
      </v-col>
      <v-col
        cols="12"
        lg="5"
        md="12"
      >
        <v-row>
          <v-col cols="12">
            <material-card
              ref="customerStatsRef"
              color="secondary"
              full-header
              class="mt-0"
            >
              <template #heading>
                <div class="pl-4 pr-4 pt-1 pb-1 white--text">
                  <div class="text-h3 font-weight-light">
                    <v-col>
                      <v-row>
                        Customer Stats
                        <v-spacer />
                        <v-btn
                          color="white"
                          icon
                          small
                          @click="customerStatsClicked"
                        >
                          <v-icon>
                            mdi-axis-arrow
                          </v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </div>
                </div>
              </template>
              <v-card-text>
                <div
                  class="pr-3 text-h3 font-weight-light"
                  style="text-align:right"
                >
                  Customer Total Trade
                </div>
                <apexchart
                  type="pie"
                  :height="pieHeight"
                  :options="tradePieData.chartOptions"
                  :series="tradePieData.series"
                />
              </v-card-text>
              <v-card-text>
                <div class="pl-3 text-h3 font-weight-light">
                  Customer Total MSF
                </div>
                <apexchart
                  type="pie"
                  :height="pieHeight"
                  :options="msfPieData.chartOptions"
                  :series="msfPieData.series"
                />
              </v-card-text>
            </material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import MaterialCard from '../components/MaterialCard.vue'
  import { customersStatsGridHeaders, salesPersonStatsGridHeaders } from '../util/gridHeaders.js'
  import { salesTradePieData, salesMSFPieData } from '@/util/chartdata.js'

  import { formatNumber, formatCurrency, formatPercentage } from '@/util/formatters.js'
  import { serverUrl } from '../../auth_config.json'
  import { get } from 'vuex-pathify'
  import { updateMenuDrawer, updateScopes } from '../auth/authorization'

  export default {
    name: 'SalesTeamPersonView',
    components: { MaterialCard },
    props: {
      salesPerson: String,
    },
    data () {
      return {
        items: [],
        sales: [],
        selectedSalesPerson: this.salesPerson,
        pieHeight: 400,
        selectedItems: [],
        tradePieData: { chartOptions: {}, series: [] },
        msfPieData: { chartOptions: {}, series: [] },
        itemsPerPage: 15,
        headers: customersStatsGridHeaders,
        salesPersonHeaders: salesPersonStatsGridHeaders,
        upImage: require('@/assets/upImage.svg'),
        downImage: require('@/assets/downImage.svg'),
      }
    },
    computed: {
      ...get('user', [
        'dark',
      ]),
    },
    async created () {
      this.getTheme()
      this.selectedSalesPerson = this.salesPerson !== undefined ? this.salesPerson : this.$auth.user.name
      const salesData = await this.fetchSales()
      updateMenuDrawer()
      this.sales = salesData.Customers
      this.items = this.workAroundForMissingSalesData(salesData)
      this.tradePieData = salesTradePieData(this.getTopTenTrade(this.sales), this.getTheme())
      this.msfPieData = salesMSFPieData(this.getTopTenMSF(this.sales), this.getTheme())
    },
    methods: {
      workAroundForMissingSalesData (salesData) {
        if (salesData.SalesPerson !== this.selectedSalesPerson) {
          return []
        }
        return [salesData]
      },
      customerGridButtonClicked () {
        const g = this.$refs.customerGridRef
        this.toggleMaxArea(g)
      },
      customerStatsClicked () {
        const g = this.$refs.customerStatsRef
        if (this.toggleMaxArea(g)) {
          this.pieHeight = (window.innerHeight / 3)
        } else {
          this.pieHeight = 400
        }
      },
      tableClicked (item, row) {
        const id = row.item
        const rowNo = this.selectedItems.indexOf(id)
        if (rowNo === -1) {
          this.selectedItems.push(id)
          row.select(true)
        } else {
          this.selectedItems.splice(rowNo, 1)
          row.select(false)
        }
        this.tradePieData = salesTradePieData(this.getTopTenTrade(this.sales), this.getTheme())
        this.msfPieData = salesMSFPieData(this.getTopTenMSF(this.sales), this.getTheme())
      },
      clearSelection () {
        const custGrid = this.$refs.CustomerGrid
        this.selectedItems = []
        custGrid.toggleSelectAll()
        this.tradePieData = salesTradePieData(this.getTopTenTrade(this.sales), this.getTheme())
        this.msfPieData = salesMSFPieData(this.getTopTenMSF(this.sales), this.getTheme())
      },
      async fetchSales () {
        try {
          const accessToken = await this.$auth.getTokenSilently()
          updateScopes(accessToken)
          const res = await fetch(`${serverUrl}/api/sales/${this.selectedSalesPerson}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          const data = await res.json()
          return data
        } catch (e) {
          return []
        }
      },
      getTopTenTrade (list) {
        if (list === undefined || list.length === 0) {
          return []
        }
        var data = [...list]
        if (this.selectedItems.length > 0) {
          data = this.selectedItems
        }
        if (data.length <= 10) { return data }
        const sorted = data.sort((a, b) => a.TotalTradeNow < b.TotalTradeNow ? 1 : -1)
        const top = sorted.slice(0, 9)
        const bottom = sorted.slice(9, sorted.length).map((a) => a.TotalTradeNow)
        const rest = { Customer: 'OTHER' }
        rest.TotalTradeNow = bottom.reduce((a, b) => a + b)
        top.push(rest)
        return top
      },
      getTopTenMSF (list) {
        if (list === undefined || list.length === 0) {
          return []
        }
        var data = [...list]
        if (this.selectedItems.length > 0) {
          data = this.selectedItems
        }
        if (data.length <= 10) { return data }
        const sorted = data.sort((a, b) => a.TotalMSFNow < b.TotalMSFNow ? 1 : -1)
        const top = sorted.slice(0, 9)
        const bottom = sorted.slice(9, sorted.length).map((a) => a.TotalMSFNow)
        const rest = { Customer: 'OTHER' }
        rest.TotalMSFNow = bottom.reduce((a, b) => a + b)
        top.push(rest)
        return top
      },
      toggleMaxArea (section) {
        var fullSize = false
        var cl = section.$el.classList
        if (cl.contains('maxArea')) {
          cl.remove('maxArea')
        } else {
          fullSize = true
          cl.add('maxArea')
        }
        return fullSize
      },
      getTheme () {
        return this.$vuetify.theme.isDark ? 'dark' : 'light'
      },
      formatNumber (number) {
        return formatNumber(number)
      },
      formatCurrency (currency) {
        return formatCurrency(currency)
      },
      formatPercentage (percentage) {
        return formatPercentage(percentage)
      },
    },
  }
</script>

<style scoped>
.v-data-table::v-deep th {
  font-size: 12px !important;
}
.maxArea {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 99%;
  width: 99%;
}
</style>
<style>
tr.v-data-table__selected {
  background-color: #1974d1 !important;
  color: white;
}
</style>
